export const ROLE_NAMES = {
  administrator: 'Administrateur',
  manager: 'Manager',
  teleoperator: 'Téléopérateur',
}
